import {createSlice} from "@reduxjs/toolkit";

const initialGuiDocumentsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  guiDocumentForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const guiDocumentsSlice = createSlice({
  name: "guiDocuments",
  initialState: initialGuiDocumentsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGuiDocumentById
    guiDocumentFetched: (state, action) => {
      state.actionsLoading = false;
      state.guiDocumentForEdit = action.payload.guiDocumentForEdit;
      state.error = null;
    },
    // findGuiDocuments
    guiDocumentsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createGuiDocument
    guiDocumentCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.guiDocument);
    },
    // updateGuiDocument
    guiDocumentUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.guiDocumentId === action.payload.guiDocument.guiDocumentId) {
          return action.payload.guiDocument;
        }
        return entity;
      });
    },
    // deleteGuiDocument
    guiDocumentDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.guiDocumentId !== action.payload.guiDocumentId);
    },
    // deleteGuiDocuments
    guiDocumentsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.guiDocumentId)
      );
    },
  }
});
